import { render, staticRenderFns } from "./kpi_detail.vue?vue&type=template&id=277ae6de&scoped=true"
import script from "./kpi_detail.vue?vue&type=script&lang=js"
export * from "./kpi_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277ae6de",
  null
  
)

export default component.exports